import { cn } from "@/lib/utils";
import type { PlacementScreenZone } from "../placementCatalog";

interface PlacementScreenThumbProps {
  zone: PlacementScreenZone;
  className?: string;
}

/** A tiny sim screen with the placement's spot highlighted — "where on screen" at a glance. */
export function PlacementScreenThumb({
  zone,
  className,
}: PlacementScreenThumbProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative block aspect-video shrink-0 overflow-hidden rounded-md bg-[#3E5B54]",
        className,
      )}
    >
      <span
        className="absolute rounded-[2px] bg-[#F2B661] outline-2 outline-white"
        style={{
          left: `${zone.left}%`,
          top: `${zone.top}%`,
          width: `${zone.width}%`,
          height: `${zone.height}%`,
        }}
      />
    </span>
  );
}
